<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>User Team Master</strong>
    </span>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" href="javascript: void(0);" data-toggle="tab" data-target="#userTeamMasterTab"
            role="tab">
            User Team Master
          </a>
        </li>
        <li class="nav-item" style="width: auto">
          <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#taskCronDetailsTab"
            role="tab">
            Tasks Cron Details
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div class="tab-pane active" id="userTeamMasterTab" role="tabcard">

          <div class="card-block datatable-card-block">
            <div class="row">
              <div class="col-md-12">
                <div class="margin-bottom-50">
                  <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                      class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                      <thead>
                        <tr>
                          <th>User Name</th>
                          <th>Colleague</th>
                          <th>Escalation 1</th>
                          <th>Escalation 2</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let user of activatedUserListForEdit" style="line-height: 25px;">
                          <td>{{user.userName }}</td>
                          <td><span *ngFor="let item of user?.colleague; let index = index">{{item?.userName}}<span
                                *ngIf="user?.colleague.length != (index + 1)">, </span></span></td>
                          <td><span *ngFor="let item of user?.escalation1;  let index = index">{{item?.userName}}<span
                                *ngIf="user?.escalation1.length != (index + 1)">, </span></span></td>
                          <td><span *ngFor="let item of user?.escalation2; let index = index">{{item?.userName}}<span
                                *ngIf="user?.escalation2.length != (index + 1)">, </span></span></td>
                          <td>
                            <button *ngIf="user.escalation2UserId==''" type="button" class="btn-sm btn btn-success"
                              title="Add"
                              (click)="addDefaultUsers(user.userId,user.userName,user.userTeamMasterId,user.colleague,user.escalation1UserId,user.escalation2UserId)">
                              <span class="fa fa-plus"></span>
                            </button>
                            <button *ngIf="user.escalation2UserId!=''" type="button" class="btn-sm btn btn-warning"
                              title="Edit"
                              (click)="addDefaultUsers(user.userId,user.userName,user.userTeamMasterId,user.colleague,user?.escalation1,user?.escalation2)">
                              <span class="fa fa-pencil"></span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade modal-size-medium" id="userTeamMasterDialog" tabindex="-1" role="dialog"
            data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <form class="well" [formGroup]="userTeamMasterForm">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabel">{{modelTitle}}</h5>
                    <!-- <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                        <i class="fa fa-times"></i>
                                      </button> -->
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-3">
                        <label class="form-control-label">User Name</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <input type="text" [readonly]="true" [formControl]="userTeamMasterForm.controls['username']"
                            class="form-control" style="padding:6px;">
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <label class="form-control-label">Colleague</label>
                      </div>
                      <div class="col-md-8">
                        <div class="form-group">
                          <ng-select placeholder="Select User" class="form-control m-b-10 p-8" [multiple]="true"
                            [formControl]="userTeamMasterForm.controls['colleague']" [items]="activatedUserList"
                            bindLabel="label" bindValue="value" 
                            (selected)="onChange($event,'Colleague', 'selected')"
                            (deselected)="onChange($event,'Colleague', 'deselected')">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="fa fa-refresh" title="Reset Colleague" (click)="resetField('colleague')"
                          style="cursor: pointer;"></div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <label class="form-control-label"> Escalation 1 </label>
                      </div>
                      <div class="col-lg-8">
                        <div class="form-group">
                          <ng-select placeholder="Select User" class="form-control m-b-10 p-8" [multiple]="true"
                            [formControl]="userTeamMasterForm.controls['escalation1']" [items]="activatedUserList"
                            bindLabel="label" bindValue="value"
                            (selected)="onChange($event,'Escalation1', 'selected')"
                            (deselected)="onChange($event,'Escalation1','deselected')">
                          </ng-select>


                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="fa fa-refresh" title="Reset Escalation 1" (click)="resetField('escalation1')"
                          style="cursor: pointer;"></div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <label class="form-control-label"> Escalation 2 </label>
                      </div>
                      <div class="col-md-8">
                        <div class="form-group">

                          <ng-select placeholder="Select User" class="form-control m-b-10 p-8" [multiple]="true"
                            [formControl]="userTeamMasterForm.controls['escalation2']" [items]="activatedUserList"
                            bindLabel="label" bindValue="value" 
                            (selected)="onChange($event, 'Escalation2', 'selected')"
                            (deselected)="onChange($event, 'Escalation2', 'deselected')">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="fa fa-refresh" title="Reset Escalation 2" (click)="resetField('escalation2')"
                          style="cursor: pointer;"></div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button id="btnsaveUserTeamMaster" type="Submit" class="btn-sm btn btn-primary"
                      (click)="addUserTeamMaster()">
                      <i class="fa fa-save"></i>{{btnTitle}}
                    </button>
                    <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="close()">
                      <i class="fa fa-times"></i>Close
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>

        <div class="tab-pane" id="taskCronDetailsTab" role="tabcard">
          <div class="form-group clearfix" style="margin-bottom: 1px;">
            <div class="col-sm-12">
              <button class="btn btn-success pull-right" (click)="addNewFieldsModal()"
                class="btn btn-sm btn-primary mb-2" type="button" style="margin-top: 10px; float:right">
                <i class="fa fa-plus"></i>Add</button>
            </div>
          </div>

          <div class="card-block datatable-card-block">
            <div class="row">
              <div class="col-md-12">
                <div class="margin-bottom-50">
                  <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptionsOfHolding" [dtTrigger]="dtTriggerHolding"
                      class="table table-hover compact cell-border nowrap stripe" id="detailsOfHoldinglistTable"
                      style="cursor: pointer;">
                      <thead>
                        <tr>
                          <th>Cron Name</th>
                          <th>Select Cron Frequency</th>
                          <th>Select Day</th>
                          <th>Select Date </th>
                          <th>No. of Days</th>
                          <th>Email To</th>
                          <th style="width: 175px">Action</th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let i of CronConfigurationsList;">
                          <td>{{i.cronName}}</td>
                          <td>{{i.cronFrequency}}</td>
                          <td>{{i.weeklyDay}}</td>
                          <td>{{i.cronDate}}</td>
                          <td>{{i.noOfDays}}</td>
                          <td>{{maskEmail(i.emailTo)}}</td>


                          <td style='white-space: nowrap; width: 118px'>
                            <a>
                              <button type="button" (click)="editholdingdetails(i._id)" class="btn-sm btn btn-warning">
                                <span class="fa fa-pencil"></span>
                              </button>
                              <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(i._id)">
                                <span class="icmn-bin"></span>
                              </button>
                            </a>

                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
          style="top: 50px;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDelete">
                  <i class="fa fa-question-circle-o mr-2"></i>Confirm
                </h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-12">
                    Are you sure you want to delete tasks cron details?
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger" (click)="deleteholdingdetail()">
                  <i class="fa fa-check"></i>Yes
                </button>
                <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                  <i class="fa fa-times"></i>No
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="addNewForm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
          style="top: 50px;" data-backdrop="static" data-keyboard="false">
          <div class="modal-dialog dynamicFieldModal" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDelete">
                  <i class="fa fa-question-circle-o mr-2"></i>Add Tasks Cron Details
                </h5>
                <button aria-label="Close" class="close" data-dismiss="modal" (click)="resetFields()" type="button">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-12">
                    <button class="btn btn-success pull-right" (click)="addNewFields()" *ngIf="addholding"
                      class="btn btn-sm btn-primary mb-2" type="button">
                      <i class="fa fa-plus"></i>Add</button>
                    <form [formGroup]="taskCronDetailsForm" class="form-horizontal">

                      <div class="col-md-12 clearfix" formArrayName="newField"
                        *ngFor="let Field of newFieldArray; let i = index;" style="border: 1px solid #b2d0ce;">
                        <div [formGroupName]="i">
                          <tr style="line-height: 42px;">


                            <td tabindex="1" style="width:100% !important; padding-top: 10px;">
                              <div class="row">
                                <ul style="list-style: none;display: flex; margin-bottom: 10px">


                                  <li>
                                    <div class="col-md-12" style="width:210px">
                                      <label [attr.for]="'cronName' + i">Cron Name<span _ngcontent-c2=""
                                          style="color: red;">*</span></label>

                                      <div class="form-group ">

                                        <input type="text" maxlength="35" class="form-control" id="cronName"
                                          [name]="'cronName' + i" formControlName="{{'cronName'}}"
                                          [formControl]="taskCronDetailsForm.controls.newField.controls[i].controls.cronName">

                                        <div
                                          *ngIf="taskCronDetailsForm.controls.newField.controls[i].controls['cronName'].hasError('pattern') && taskCronDetailsForm.controls.newField.controls[i].controls['cronName'].touched"
                                          class="form-control-error-custom">
                                          Cron Name is invalid
                                        </div>
                                        <div
                                          *ngIf="taskCronDetailsForm.controls.newField.controls[i].controls['cronName'].hasError('required') && taskCronDetailsForm.controls.newField.controls[i].controls['cronName'].touched"
                                          class="form-control-error-custom">
                                          Cron Name is required
                                        </div>
                                      </div>
                                    </div>
                                  </li>


                                  <li>
                                    <div class="col-md-12" style="width:210px">
                                      <div class="form-group">
                                        <label [attr.for]="'cronFrequency' + i">Select Cron Frequency</label>
                                        <span _ngcontent-c2="" style="color: red;">*</span>
                                        <select class="form-control" name="cronFrequency" id="cronFrequency"
                                          formControlName="cronFrequency"
                                          [formControl]="taskCronDetailsForm.controls.newField.controls[i].controls['cronFrequency']"
                                          (change)="changeTransactionType(taskCronDetailsForm.controls.newField.controls[i].controls['cronFrequency'].value)"
                                          [value]="taskCronDetailsForm.controls.newField.controls[i].controls['cronFrequency'].value"
                                          style="padding:6px;">

                                          <option value="" [selected]="true">Select</option>
                                          <option value="Weekly"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronFrequency'].value =='Weekly'">
                                            Weekly </option>
                                          <option value="Monthly"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronFrequency'].value == 'Monthly'">
                                            Monthly </option>

                                        </select>

                                        <div
                                          *ngIf="taskCronDetailsForm.controls.newField.controls[i].controls['cronFrequency'].hasError('required') && taskCronDetailsForm.controls.newField.controls[i].controls['cronFrequency'].touched"
                                          class="form-control-error-custom">
                                          Select Cron Frequency is required
                                        </div>
                                      </div>
                                    </div>
                                  </li>

                                  <li>
                                    <div class="col-md-12">
                                      <div class="form-group"
                                        *ngIf="taskCronDetailsForm.controls.newField.value[i]['cronFrequency'] == 'Weekly'">
                                        <label [attr.for]="'weeklyDay' + i">Select Day <span _ngcontent-c2=""
                                            style="color: red;">*</span></label>
                                        <select _ngcontent-c2="" class="form-control" name="weeklyDay" id="weeklyDay"
                                          formControlName="weeklyDay"
                                          [formControl]="taskCronDetailsForm.controls.newField.controls[i].controls['weeklyDay']"
                                          [value]="taskCronDetailsForm.controls.newField.controls[i].controls['weeklyDay'].value"
                                          style="padding:6px;width:180px">

                                          <option _ngcontent-c2="" value="" [selected]="true">
                                            Select
                                          </option>
                                          <option _ngcontent-c2="" value="Sunday"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['weeklyDay'].value=='Sunday'">
                                            Sunday</option>
                                          <option _ngcontent-c2="" value="Monday"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['weeklyDay'].value=='Monday'">
                                            Monday</option>
                                          <option _ngcontent-c2="" value="Tuesday"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['weeklyDay'].value=='Tuesday'">
                                            Tuesday</option>
                                          <option _ngcontent-c2="" value="Wednesday"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['weeklyDay'].value=='Wednesday'">
                                            Wednesday</option>
                                          <option _ngcontent-c2="" value="Thursday"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['weeklyDay'].value=='Thursday'">
                                            Thursday</option>
                                          <option _ngcontent-c2="" value="Friday"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['weeklyDay'].value=='Friday'">
                                            Friday</option>
                                          <option _ngcontent-c2="" value="Saturday"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['weeklyDay'].value=='Saturday'">
                                            Saturday</option>

                                        </select>

                                        <div
                                          *ngIf="taskCronDetailsForm.controls.newField.controls[i].controls['weeklyDay'].hasError('required') && taskCronDetailsForm.controls.newField.controls[i].controls['weeklyDay'].touched"
                                          class="form-control-error-custom">
                                          Select Day is required</div>

                                      </div>
                                    </div>
                                  </li>

                                  <li>
                                    <div class="col-md-12">
                                      <div class="form-group"
                                        *ngIf="taskCronDetailsForm.controls.newField.value[i]['cronFrequency'] == 'Monthly'">
                                        <label [attr.for]="'cronDate' + i">Select Date <span _ngcontent-c2=""
                                            style="color: red;">*</span></label>
                                        <select _ngcontent-c2="" class="form-control " name="cronDate" id="cronDate"
                                          formControlName="cronDate"
                                          [formControl]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate']"
                                          [value]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value"
                                          style="padding:6px;width:180px">

                                          <option _ngcontent-c2="" value="" [selected]="true">Select</option>


                                          <option _ngcontent-c2="" value="1"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='1'">
                                            1 </option>
                                          <option _ngcontent-c2="" value="2"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='2'">
                                            2 </option>
                                          <option _ngcontent-c2="" value="3"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='3'">
                                            3 </option>
                                          <option _ngcontent-c2="" value="4"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='4'">
                                            4 </option>
                                          <option _ngcontent-c2="" value="5"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='5'">
                                            5 </option>
                                          <option _ngcontent-c2="" value="6"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='6'">
                                            6 </option>
                                          <option _ngcontent-c2="" value="7"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='7'">
                                            7 </option>
                                          <option _ngcontent-c2="" value="8"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='8'">
                                            8 </option>
                                          <option _ngcontent-c2="" value="9"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='9'">
                                            9 </option>
                                          <option _ngcontent-c2="" value="10"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='10'">
                                            10 </option>
                                          <option _ngcontent-c2="" value="11"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='11'">
                                            11 </option>
                                          <option _ngcontent-c2="" value="12"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='12'">
                                            12 </option>
                                          <option _ngcontent-c2="" value="13"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='13'">
                                            13 </option>
                                          <option _ngcontent-c2="" value="14"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='14'">
                                            14 </option>
                                          <option _ngcontent-c2="" value="15"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='15'">
                                            15 </option>
                                          <option _ngcontent-c2="" value="16"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='16'">
                                            16 </option>
                                          <option _ngcontent-c2="" value="17"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='17'">
                                            17 </option>
                                          <option _ngcontent-c2="" value="18"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='18'">
                                            18 </option>
                                          <option _ngcontent-c2="" value="19"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='19'">
                                            19 </option>
                                          <option _ngcontent-c2="" value="20"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='20'">
                                            20 </option>
                                          <option _ngcontent-c2="" value="21"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='21'">
                                            21 </option>
                                          <option _ngcontent-c2="" value="22"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='22'">
                                            22 </option>
                                          <option _ngcontent-c2="" value="23"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='23'">
                                            23 </option>
                                          <option _ngcontent-c2="" value="24"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='24'">
                                            24 </option>
                                          <option _ngcontent-c2="" value="25"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='25'">
                                            25 </option>
                                          <option _ngcontent-c2="" value="26"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='26'">
                                            26 </option>
                                          <option _ngcontent-c2="" value="27"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='27'">
                                            27 </option>
                                          <option _ngcontent-c2="" value="28"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='28'">
                                            28 </option>
                                          <option _ngcontent-c2="" value="29"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='29'">
                                            29 </option>
                                          <option _ngcontent-c2="" value="30"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='30'">
                                            30 </option>
                                          <option _ngcontent-c2="" value="31"
                                            [selected]="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].value=='31'">
                                            31 </option>


                                        </select>
                                        <div
                                          *ngIf="taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].hasError('required') && taskCronDetailsForm.controls.newField.controls[i].controls['cronDate'].touched"
                                          class="form-control-error-custom">
                                          Select Date is required</div>
                                      </div>
                                    </div>
                                  </li>

                                  <li>
                                    <div class="col-md-12" style="width:210px">
                                      <div class="form-group">
                                        <label [attr.for]="'noOfDays' + i">No. of Days<span _ngcontent-c2=""
                                            style="color: red;">*</span></label>
                                        <input type="text" maxlength="10" class="form-control" id="noOfDays"
                                          [name]="'noOfDays' + i " formControlName="{{'noOfDays'}}"
                                          [formControl]="taskCronDetailsForm.controls.newField.controls[i].controls.noOfDays">

                                        <div
                                          *ngIf="taskCronDetailsForm.controls.newField.controls[i].controls['noOfDays'].hasError('pattern') && taskCronDetailsForm.controls.newField.controls[i].controls['noOfDays'].touched"
                                          class="form-control-error-custom">
                                          No. of Days is invalid
                                        </div>
                                        <div
                                          *ngIf="taskCronDetailsForm.controls.newField.controls[i].controls['noOfDays'].hasError('required') && taskCronDetailsForm.controls.newField.controls[i].controls['noOfDays'].touched"
                                          class="form-control-error-custom">
                                          No. of Days is required
                                        </div>
                                      </div>
                                    </div>
                                  </li>

                                  <li>
                                    <div class="col-md-12" style="width:210px">
                                      <div class="form-group">
                                        <label [attr.for]="'emailTo' + i">Email To<span _ngcontent-c2=""
                                            style="color: red;">*</span></label>
                                        <textarea class="form-control" maxlength="40" id="emailTo"
                                          [name]="'emailTo' + i " formControlName="{{'emailTo'}}"
                                          [formControl]="taskCronDetailsForm.controls.newField.controls[i].controls.emailTo"> </textarea>
                                        <div
                                          *ngIf="taskCronDetailsForm.controls.newField.controls[i].controls['emailTo'].hasError('pattern') && taskCronDetailsForm.controls.newField.controls[i].controls['emailTo'].touched"
                                          class="form-control-error-custom">
                                          Email To is invalid
                                        </div>
                                        <div
                                          *ngIf="taskCronDetailsForm.controls.newField.controls[i].controls['emailTo'].hasError('required') && taskCronDetailsForm.controls.newField.controls[i].controls['emailTo'].touched"
                                          class="form-control-error-custom">
                                          Email To is required
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </td>
                            <td style='white-space: nowrap;padding-right:20px;padding-left:10px;'>
                              <button type="button" class="btn-sm btn btn-danger" (click)="removeField(i)"
                                *ngIf="addholding">
                                <span class="icmn-bin"></span>
                              </button>
                            </td>
                          </tr>
                        </div>
                      </div>

                    </form>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" *ngIf="addholding" (click)="saveDetailsOfHolding()"
                  [disabled]="!(taskCronDetailsForm.valid) || disabledOnClick">
                  <i class="fa fa-check"></i>Save
                </button>
                <button type="button" class="btn btn-sm btn-primary" *ngIf="!addholding"
                  (click)="updateHoldingDetails()" [disabled]="!(taskCronDetailsForm.valid) || disabledOnClick">
                  <i class="fa fa-check"></i>Update
                </button>

                <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal" (click)="resetFields()">
                  <i class="fa fa-times"></i>No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-alert></app-alert>
</section>